var exports = {
  "container": "xa15a2ab7--ed6998--container",
  "container_fullwidth": "xa15a2ab7--ed6998--container_fullwidth",
  "container-size-xs": "xa15a2ab7--ed6998--container-size-xs",
  "container-size-m": "xa15a2ab7--ed6998--container-size-m",
  "container-size-l": "xa15a2ab7--ed6998--container-size-l",
};

module.exports = exports;
